import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { FeatureService } from '../../services/feature.service';

export const authGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const msalService = inject(MsalService);
  const authService = inject(AuthService);
  const featureService = inject(FeatureService);

  await msalService.instance.initialize();

  const active = msalService.instance.getActiveAccount();
  const accounts = msalService.instance.getAllAccounts();

  if (!active && accounts.length > 0) {
    msalService.instance.setActiveAccount(accounts[0]);
  }

  const account =
    msalService.instance.getActiveAccount() ??
    msalService.instance.getAllAccounts()[0];

  if (!account) {
    return router.parseUrl('/login');
  }

  const autenticado = await firstValueFrom(authService.checkAuth());

  if (autenticado) {
    await firstValueFrom(featureService.ensureLoaded());
    return true;
  }

  return router.parseUrl('/login?error=unauthorized');
};